export default {
  // TODO: Translate (PWA)
  error: {
    trace: 'Rastro: {n}',
    api: {
      response: 'Hubo un problema con la respuesta del servidor'
    },
    pin: {
      'INVALID-PIN-LENGTH': 'El PIN no tenía el largo correcto',
      'INVALID-PIN': 'Se ha proporcionado un PIN no válido',
      'NO-TRANSACTION-DATA': 'Not Implemented.',
      'NO-ACCOUNT': 'Se ha proporcionado un PIN no válido (Error: 1)',
      'NO-BRANCH': 'Se ha proporcionado un PIN no válido (Error: 2)',
      'NO-COMPANY': 'Se ha proporcionado un PIN no válido (Error: 3)'
    },
    tableNumber: {
      'INVALID-PIN-LENGTH': 'Not Implemented.',
      'INVALID-PIN': 'Not Implemented.',
      'NO-TRANSACTION-DATA': 'Not Implemented.',
      'NO-ACCOUNT': 'Not Implemented.',
      'NO-BRANCH': 'Not Implemented.',
      'NO-COMPANY': 'Not Implemented.'
    }
  }
};